var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Close"),React.createElement("g",{"key":1},React.createElement("path",{"d":"M9.76,77.76,39.52,48,9.76,18.24a6,6,0,1,1,8.49-8.48L48,39.52,77.76,9.76a6,6,0,1,1,8.49,8.48L56.48,48,86.24,77.76a6,6,0,1,1-8.49,8.48L48,56.48,18.24,86.24a6,6,0,0,1-8.49-8.48Z"}))]);
}

CloseInline.defaultProps = {"height":"100px","width":"100px","fill":"currentColor","viewBox":"0 0 96 96","x":"0px","y":"0px"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
